import { Checkbox } from "@mantine/core";
import { useHeldEmailCheckbox } from "../../../hooks/admin/useHeldEmailSelection";
import { HeldEmailSelectionModel } from "./heldEmailSelection";

interface HeldEmailSelectionCheckboxProps {
  id: string;
  label: string;
  checked: boolean;
  disabled: boolean;
  selection: HeldEmailSelectionModel;
}

export function HeldEmailSelectionCheckbox({
  id,
  label,
  checked,
  disabled,
  selection,
}: HeldEmailSelectionCheckboxProps) {
  const handleChange = useHeldEmailCheckbox(selection, id);
  return (
    <Checkbox
      aria-label={`Select ${label}`}
      checked={checked}
      disabled={disabled}
      onChange={handleChange}
    />
  );
}
